import React, { useState, useEffect } from 'react';
import axios from '../Common/axios';
import { Table, Divider, InputNumber, Button, Tag, Modal } from "antd";
import { getGridTableHeight } from '../Common/util';
import { getFindReportIdInfo, getEditDoa, postEditVaReportData } from '../../pages/Common/api';

/** -------------------------------------------------------------------------- **/
function Item({ reportId, itemList, riskScoreList, riskGradeList, doa, onChangeAfter }) {

    // 위험등급기준
    const [reportInfo, setReportInfo] = useState({});
    const [RiskGrdHigh, setRiskGrdHigh] = useState(12);  //12이상이면 High
    const [RiskGrdRow, setRiskGrdRow] = useState(5);    //5이하이면 Row

    useEffect(() => {
        //자동조회
        if (reportId) {
            findReportIdInfo();
        }
    }, [reportId]);

    // 레포트조회
    const findReportIdInfo = () => {
        axios.get(getFindReportIdInfo(reportId))
            .then((response) => {
                //console.log(response);
                setReportInfo(response.data[0]);
                setRiskGrdHigh(response.data[0].risk_grd_high);
                setRiskGrdRow(response.data[0].risk_grd_low);
            })
            .catch((error) => {
                console.log("Item.js --- 45 error");
                console.dir(error);
            });
    }

    // const onClickSaveHandler = () => {       
    //     axios.post(postEditVaReportData(), {
    //             reportId : reportInfo.report_id,
    //             companyCode : reportInfo.com_cd,
    //             assetType : reportInfo.asset_type,
    //             reportName : reportInfo.report_nm,
    //             reportDesc : reportInfo.report_desc,
    //             createdYmd : reportInfo.created_ymd,
    //             updatedYmd : reportInfo.updated_ymd,
    //             confirm : reportInfo.confirm,
    //             risk_grd_high : RiskGrdHigh,
    //             risk_grd_low : RiskGrdRow,
    //     }, {logCompany : reportInfo.com_cd, logParam : reportInfo.report_id})
    //     .then((response) => {
    //             if(response.status === 200) {
    //                 Modal.info({title: "정상적으로 수정되었습니다.", okText:"Close", onOk() {
    //                     onChangeAfter(true);
    //                 }});
    //             } 
    //     })
    //     .catch((error) => {
    //             Modal.error({title: "Error.", okText:"Close"});
    //     });
    // };

    const itemColumnData = [
        {
            title: '분류',
            align: 'center',
            colSpan: 2,
            rowSpan: 2,
            children: [
                {
                    title: ' ',
                    dataIndex: 'measure_type',
                    key: 'measure_type',
                    width: '70px',
                    align: 'center',
                    fixed: 'left',
                    render :(text)=>text,
                    onCell : (record, index)=>{
                        let rowSpan = 0;
                        let value = record.measure_type;

                        if (index > -1 && value == itemList[index - 1]?.measure_type) {
                            rowSpan = 0;
                        } else {
                            for (
                                let i = 0;
                                index + i != itemList.length &&
                                value == itemList[index + i]?.measure_type;
                                i += 1
                            ) {
                                rowSpan = i + 1;
                            }
                        }
                        return {rowSpan};
                    },
                    // render: (value, row, index) => {
                    //     const obj = {
                    //         children: value,
                    //         props: {},
                    //     }
                    //     if (index > -1 && value == itemList[index - 1]?.measure_type) {
                    //         obj.props.rowSpan = 0;
                    //     } else {
                    //         for (
                    //             let i = 0;
                    //             index + i != itemList.length &&
                    //             value == itemList[index + i]?.measure_type;
                    //             i += 1
                    //         ) {
                    //             obj.props.rowSpan = i + 1;
                    //         }
                    //     }
                    //     return obj;
                    // },
                    colSpan: 0,
                },
                {
                    title: ' ',
                    dataIndex: 'measure_cd',
                    key: 'measure_cd',
                    width: '80px',
                    align: 'center',
                    fixed: 'left',
                    colSpan: 0,
                },
            ]
        },
        {
            title: '진단 항목',
            dataIndex: 'measure_nm',
            key: 'measure_nm',
            width: '240px',
            align: 'left',
            fixed: 'left',
            ellipsis: false,

        },
        {
            title: '중요도',
            dataIndex: 'important_grd',
            key: 'important_grd',
            width: '50px',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
        },
        {
            title: '위험평가 통계',
            align: 'center',
            className: 'fix_col',
            children: [
                {
                    title: '전체',
                    dataIndex: 'stat_measure_total',
                    key: 'stat_measure_total',
                    width: '70px',
                    align: 'center',
                    className: 'fix_col',
                },
                {
                    title: '전체위험',
                    dataIndex: 'stat_measure_total_risk',
                    key: 'stat_measure_total_risk',
                    width: '70px',
                    align: 'center',
                    className: 'fix_col',
                },
                {
                    title: 'H',
                    dataIndex: 'stat_measure_H',
                    key: 'stat_measure_H',
                    width: '50px',
                    align: 'center',
                    className: 'fix_col',
                },
                {
                    title: 'M',
                    dataIndex: 'stat_measure_M',
                    key: 'stat_measure_M',
                    width: '50px',
                    align: 'center',
                    className: 'fix_col',
                },
                {
                    title: 'L',
                    dataIndex: 'stat_measure_L',
                    key: 'stat_measure_L',
                    width: '50px',
                    align: 'center',
                    className: 'fix_col',

                },
                {
                    title: '위험도0',
                    dataIndex: 'stat_measure_Zero',
                    key: 'stat_measure_Zero',
                    width: '50px',
                    align: 'center',
                    className: 'fix_col',
                },
            ]
        },
    ];
    
    const renderDoaValue = (doa, value) => {
        if (value >= parseInt(doa)) {
            return (<span style={{ color: 'red' }}> {value} </span>);
        } else {
            return (value);
        }
    };
    /* 자산코드 열로 나열 */
    let assetColumns = [];
    let assetColumns_render = [];
    let keys;
    let assetKeys = [];
    if (itemList.length > 0) {
        keys = Object.keys(itemList[0]);
        keys.map((key) => {
            if (key.substring(0, 2) == '__') {
                assetKeys.push(key);
                assetColumns.push(
                    {
                        title: key.substring(2),
                        dataIndex: key,
                        key: key,
                        width: '60px',
                        align: 'center',
                    }
                );
                assetColumns_render.push(
                    {
                        title: key.substring(2),
                        dataIndex: key,
                        key: key,
                        width: '60px',
                        align: 'center',
                        render: (value) => {
                            if (value >= parseInt(doa)) {
                                // return (<span style={{ color: 'red' }}> {value} </span>);
                                return renderDoaValue(doa,value);
                            } else {
                                return (value);
                            }
                        },
                        // render: (value) => {
                        //     if (value >= parseInt(RiskGrdHigh)) {
                        //         return (<span style={{ color: 'red' }}> {value} </span>);
                        //     } else if (value >= parseInt(RiskGrdRow)) {
                        //         return (<span style={{ color: 'blue' }}> {value} </span>);
                        //     } else {
                        //         return (value);
                        //     }
                        // },
                    }
                )
            }
        })
        //console.log(assetKeys);
    }

    /* 위험평가 항목별 통계 */
    const columns = [...itemColumnData];
    assetColumns_render.map((col) => {
        columns.push(col);
    })

    /* 위험등급별 통계 */
    const itemGradeColumn = [
        {
            title: '위험등급',
            dataIndex: 'risk_grade',
            key: 'risk_grade',
            width: '100px',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
        },
        {
            title: '합계',
            dataIndex: 'sum',
            key: 'sum',
            width: '70px',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
        },
    ];
    assetColumns.map((col) => {
        itemGradeColumn.push(col);
    })

    /* 위험도별 통계 */
    const itemScoreColumn = [
        {
            title: '위험도',
            dataIndex: 'risk_score',
            key: 'risk_score',
            width: '100px',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
        },
        {
            title: '합계',
            dataIndex: 'sum',
            key: 'sum',
            width: '70px',
            align: 'center',
            fixed: 'left',
            ellipsis: true,
        },
    ];
    assetColumns.map((col) => {
        itemScoreColumn.push(col);
    })

    return (
        <>
            <div id="divTabs2" className="section" style={{height: getGridTableHeight(180), overflowY: 'auto' }}>
                <div className="sub_title">
                    {'■ 위험평가 항목별 통계'} <span style={{position:"absolute", right:"50px",color:"red"}}>* 설정된 DoA 값보다 높은 위험은 빨간색으로 표시됩니다.</span> 
                </div>
                <div style={{ padding: '5px 10px' }}>
                    <Table columns={columns}
                        dataSource={itemList}
                        rowKey="measure_cd"
                        bordered size={"small"}
                        className="sub_table"
                        scroll={{ x: 800, y: 480 }}       
                        pagination={false}               
                    >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                    {'■ 위험등급별 통계'}
                </div>
                <div style={{ padding: '5px 10px' }}>
                    <Table columns={itemGradeColumn}
                        dataSource={riskGradeList}     
                        rowKey="risk_grade"
                        bordered size={"small"}
                        className="sub_table"
                        scroll={{ x: 800, y: 300 }}
                        pagination={false}
                    >
                    </Table>
                </div>
                <Divider />
                <div className="sub_title">
                    {'■ 위험도별 통계'}
                </div>
                <div style={{ padding: '5px 10px' }}>
                    <Table columns={itemScoreColumn}
                        dataSource={riskScoreList}                   
                        rowKey="risk_score"
                        virtual={true} 
                        bordered size={"small"}
                        className="sub_table"
                        scroll={{ x: 800, y: 450 }}
                        pagination={false}
                    >
                    </Table>
                </div>
                &nbsp;<br />
            </div>
        </>
    );
}
export default Item;